import React, { useMemo } from 'react';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import _ from 'lodash';
import {
    ConditionOp,
    ExpressionPath,
} from '../types';
import { getOps } from '../utils';


export const defaultProps: SxProps<Theme> = {
    padding: 0,
    margin: 0,
}

export const selectedProps: SxProps<Theme> = {
    ...defaultProps,
    background: theme => theme.palette.primary.main,
    color: theme => theme.palette.common.white,
}

export const normalProps: SxProps<Theme> = {
    ...defaultProps,
}

const OpSelector: React.FC<{
    lhs: ExpressionPath,
    anchorEl: Element | null
    onClose: () => void,
    selected: ConditionOp,
    onSelect: (op: ConditionOp) => void,
}> = ({
    lhs,
    anchorEl,
    onClose,
    selected,
    onSelect,
}) => {
        const ops: ConditionOp[] = useMemo(
            () => getOps(lhs),
            [lhs]
        );

        const handleSelect = (op: ConditionOp) => () => {
            onSelect(op);
            onClose();
        }

        return <Popover
            id={'operators-popover'}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {
                    ops.map(op => {
                        return <ListItem
                            key={op.name}
                            sx={selected == op ? selectedProps : normalProps}
                            onClick={handleSelect(op)}
                        >
                            <ListItemButton>
                                <ListItemText id={op.name} primary={`${op.label}`} />
                            </ListItemButton>
                        </ListItem>
                    })
                }
                <Box textAlign='center'>
                    <Button
                        onClick={onClose}
                        variant='contained'
                        sx={{ m: 1 }}
                        size='small'
                    >
                        {'Cancel'}
                    </Button>
                </Box>
            </List>
        </Popover>
    }

export default OpSelector;
